import { render, staticRenderFns } from "./ReportingHistory.vue?vue&type=template&id=2939b1b0"
import script from "./ReportingHistory.vue?vue&type=script&lang=js"
export * from "./ReportingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports